import { useRef, useState } from 'react';
import API from '../api';
import toastr from 'toastr';
import { downloadBlob } from '../utils/downloadFile';

export default function useLabBackup() {
  const [labBackingUp, setLabBackingUp] = useState(false);
  const inProgress = useRef(false);
  const downloadLabBackup = async () => {
    if (inProgress.current) return;
    inProgress.current = true;
    setLabBackingUp(true);
    try {
      const response = await API.post('/backup/labBackup', undefined, { responseType: 'blob' });
      const disposition = response.headers['content-disposition'] || '';
      const filename = disposition.match(/filename="([^"\r\n]+)"/)?.[1] || 'lab_backup.sql';
      downloadBlob(response.data, filename);
      toastr.success('Lab Backup downloaded');
    } catch {
      toastr.error('Lab Backup failed. Please try again.');
    } finally {
      inProgress.current = false;
      setLabBackingUp(false);
    }
  };
  return { labBackingUp, downloadLabBackup };
}
